module.exports = __webpack_public_path__ + "img/ic24Aboutus.42e0e363.svg";